import * as yup from 'yup';
import {AutomatedNotificationType, NotificationTriggerType} from "../../../Component/Model/Enum/BEE123Enums";

export const AutomatedNotificationValidationSchema = yup.object().shape({
	additionalUsers: yup.array().of(
		yup
			.string()
			.required()
			.test('check-email', '${value} is not a valid email address', (value) => {
				return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i.test(value!);
			})
	),
	automatedNotificationTypeId: yup
		.number()
		.nullable()
		.required('Notification Type is required')
		.typeError('Notification Type required'),
	message: yup
		.string()
		.required('Message is required')
		.max(255,'Maximum message length is 255 characters.'),
	usersToNotify: yup
		.array()
		.of(yup.string().required())
		.min(1, 'Users to Notify is required'),
	stepToAction: yup
		.number()
		.required('Step is required')
		.typeError('Step is required'),
	statusToAction: yup
		.string()
		.when(['automatedNotificationTypeId', 'notificationTrigger'], {
			is: (automatedNotificationTypeId: number, notificationTrigger: string) =>
				automatedNotificationTypeId === AutomatedNotificationType.Application_Status_Tracker ||
				notificationTrigger === NotificationTriggerType.StatusChangePlanner.toString(),
			then: yup
				.string()
				.required('Status is required')
				.typeError('Status is required'),
			otherwise: yup
				.string()
				.nullable(),
		}),
	daysElapsed: yup
		.number()
		.transform((curr, orig) => (orig === '' ? null : curr))
		.typeError('Must be a valid number')
		.min(0, 'Must be greater than 0 days')
		.max(365, 'Must be less than or equal to 365 days')
		.nullable()
		.when('notificationTrigger', {
			is: NotificationTriggerType.DaysElapsed.toString(),
			then: yup
				.number()
				.transform((curr, orig) => (orig === '' ? null : curr))
				.typeError('Must be a valid number')
				.required('Number of days elapsed required')	
				.min(0, 'Must be greater than 0 days')
		}),
	numberOfDaysToSendBeforeScheduleDate: yup
		.number()
		.transform((curr, orig) => (orig === '' ? null : curr))
		.typeError('Must be a valid number')
		.min(0, 'Must be greater than 0 days')
		.max(365, 'Must be less than or equal to 365 days')
		.nullable()
		.when('notificationTrigger', {
			is: NotificationTriggerType.ScheduledDate.toString(),
			then: yup
				.number()
				.transform((curr, orig) => (orig === '' ? null : curr))
				.typeError('Must be a valid number')
				.test('oneOfFields', 'Please capture the number of days before or after the scheduled date', function (value) {
					const { numberOfDaysToSendBeforeScheduleDate, numberOfDaysToSendAfterScheduleDate } = this.parent;
					if ((numberOfDaysToSendBeforeScheduleDate === null || numberOfDaysToSendBeforeScheduleDate === undefined) && (numberOfDaysToSendAfterScheduleDate === null || numberOfDaysToSendAfterScheduleDate === undefined)) {
						return false;
					}
					return true;
				}).nullable()
		}),	
	numberOfDaysToSendAfterScheduleDate: yup
		.number()
		.transform((curr, orig) => (orig === '' ? null : curr))
		.typeError('Must be a valid number')
		.min(0, 'Must be greater than 0 days')
		.max(365, 'Must be less than or equal to 365 days')
		.nullable()
		.when('notificationTrigger', {
			is: NotificationTriggerType.ScheduledDate.toString(),
			then: yup
				.number()
				.transform((curr, orig) => (orig === '' ? null : curr))
				.typeError('Must be a valid number')
				.test('oneOfFields', 'Please capture the number of days before or after the scheduled date', function (value) {
					const { numberOfDaysToSendBeforeScheduleDate, numberOfDaysToSendAfterScheduleDate } = this.parent;
					if ((numberOfDaysToSendBeforeScheduleDate === null || numberOfDaysToSendBeforeScheduleDate === undefined) && (numberOfDaysToSendAfterScheduleDate === null || numberOfDaysToSendAfterScheduleDate === undefined)) {
						return false;
					}
					return true;
				}).nullable()
		}),
	notificationTrigger: yup
		.string()
		.when('automatedNotificationTypeId', {
			is: (automatedNotificationTypeId : number) =>
				automatedNotificationTypeId === AutomatedNotificationType.Scorecard_Planner_And_Tracker,
			then: yup.string().required('Notification Trigger is required').typeError('Notification Trigger is required'),
			otherwise: yup.string().nullable()
		})
});
